const init = {
  sports: [],
  achievements: [],
  roster: [],
  teams: [],
  tournaments: [],
  leaderboard: [],
  groundBookings: [],
  mySport: [],
  myPerformance: null,
  loading: false,
};
export const sportsReducer = (state = init, action) => {
  switch (action.type) {
    case "SPORTS_REQUEST":
      return { ...state, loading: true };
    case "SPORTS_SUCCESS":
      return { ...state, loading: false, sports: action.payload };
    case "SPORTS_FAIL":
      return { ...state, loading: false };
    case "ACHIEVEMENTS_SUCCESS":
      return { ...state, achievements: action.payload };
    case "ROSTER_SUCCESS":
      return { ...state, roster: action.payload };
    case "TEAMS_SUCCESS":
      return { ...state, teams: action.payload };
    case "TOURNAMENTS_SUCCESS":
      return { ...state, tournaments: action.payload };
    case "LEADERBOARD_SUCCESS":
      return { ...state, leaderboard: action.payload };
    case "GROUND_BOOKINGS_SUCCESS":
      return { ...state, groundBookings: action.payload };
    case "MY_SPORT_SUCCESS":
      return { ...state, mySport: action.payload };
    case "MY_PERFORMANCE_SUCCESS":
      return { ...state, myPerformance: action.payload };
    default:
      return state;
  }
};
